import { render, staticRenderFns } from "./venomfaq.vue?vue&type=template&id=1a9560a5&scoped=true&"
import script from "./venomfaq.vue?vue&type=script&lang=js&"
export * from "./venomfaq.vue?vue&type=script&lang=js&"
import style0 from "./venomfaq.vue?vue&type=style&index=0&id=1a9560a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9560a5",
  null
  
)

export default component.exports